var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vinnuskoli-page',[_c('p',[_vm._v("Vinsamlegast veldu sveitarfélag hér að ofan.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }